import { Box, CardContent, Stack, Typography, CardMedia } from "@mui/material";
import React, { ReactNode } from "react";
import { TruncatedText } from "../../Typography/Typography.style";
import { Product } from "component/MarketPlace/ProductCard/types";
import {
  CardMediaWrapper,
  StyledCard,
  StyledCardActions,
} from "./ProductCompareCard.style";
import {
  CardHeader,
} from "component/MarketPlace/ProductCard/components";
import { convertNumberToCurrency } from "utils/functions";
import PlaceHolderImage from '../../../../assets/images/marketplace/PlaceholderCompare.jpg';



export interface ProductCompareCardProps {
  product: Product;
  action?: ReactNode;
  showPrice?: boolean;
  onCardClick?: (product: Product) => void;
  locale: any;
}

const ProductCompareCard = (props: ProductCompareCardProps) => {
  const { product, action, onCardClick, showPrice = false, locale} = props;

  const BlankCard = () => {
    return(
    <StyledCard elevation={0} onClick={() => {}}>
      <CardMedia
        component={"img"}
        title="Blank Card"
        image={PlaceHolderImage}
        sx={{ height:"196px", aspectRatio: "1" }}
        aria-label="blank-card"
        alt="Blank Card"
      />
      <CardContent>
        <Box justifyContent="center" alignItems="center" display="flex" mt="70px">
          <Typography variant="body1" gutterBottom={false} sx={{color:"text.disabled",textAlign:"center"}}>{locale?.productDetail?.chooseItemToCompare}</Typography>
        </Box>
      </CardContent>
    </StyledCard>
    );
  }

  if (!product) return <BlankCard />;

  const picture = product.pictures[0] || {};
  const pictureUrl = picture.large || picture.medium || picture.small || "";

  const price = product.mock?.price;

  const currency = product.currency;

  const convertPrice = (price: any) => {
    return convertNumberToCurrency(price, currency);
  };


  return (
    <StyledCard elevation={0} onClick={() => onCardClick?.(product)}>
      <CardMediaWrapper flexShrink={0}>
        <CardMedia
          image={pictureUrl}
          sx={{ objectFit: "contain", aspectRatio: "1" }}
          aria-label={product.name}
          component={"img"}
          title={product.name}
          alt={product.name}
        />
      </CardMediaWrapper>

      <Stack direction="column" flex={1} justifyContent="space-between">
        <Box>
          <Typography
            variant="overline"
            color="text.secondary"
            textTransform="uppercase"
            letterSpacing={0.2}
          >
            {product.brand.name}
          </Typography>
          <CardHeader
            title={
              <TruncatedText
                maxlines={1}
                variant="h5"
                title={product.name}
                width="fit-content"
              >
                {product.name}
              </TruncatedText>
            }
            sx={{
              padding:"0px"
            }}
          />
        </Box>
        {showPrice && <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textDecorationLine: 'line-through' }}
          >
            {convertPrice(price?.msrp)}
          </Typography>

          <Typography variant="h5">{convertPrice(price?.current)}</Typography>
        </Box>}

        {action && (
          <StyledCardActions onClick={(e : any) => e.stopPropagation()}>
            {action}
          </StyledCardActions>
        )}
      </Stack>
    </StyledCard>
  );
};

export default ProductCompareCard;
